<eds-staggered-visual
  [preTitle]="content?.preTitle"
  [title]="content?.title"
  [summary]="content?.summary"
  [imageSrc]="content?.imageSrc"
  [isContentLeft]="content?.isContentLeft"
  [btnLabel]="content?.link.displayText"
  [href]="content?.link.url"
  [btnType]="'secondary'"
  [isNewWindow]="content?.link.target"
  [externalLink]="content?.link.external"
  [secondaryTheme]="secondaryTheme"
></eds-staggered-visual>
